import { render } from "./ProfileView.vue?vue&type=template&id=6602ea7f&scoped=true"
const script = {}

import "./ProfileView.vue?vue&type=style&index=0&id=6602ea7f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6602ea7f"]])

export default __exports__